<!--<script setup>-->

<!--</script>-->

<!--<template>-->
<!--  &lt;!&ndash; 动态内容区（根据路由变化） &ndash;&gt;-->
<!--  <router-view></router-view>-->
<!--</template>-->

<!--<style>-->

<!--</style>-->


<template>
  <router-view></router-view>
</template>

<script setup>
</script>

<style>
#app {
  height: 100vh;
  overflow: hidden;
  margin: 0;
  padding: 0;
}
:root {
  --header-height: 48px;
  --tabs-height: 40px;
  --footer-height: 40px;
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}
::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
.el-notification {
  max-width: 400px !important;
}
</style>